import { z } from 'zod';

import { OrgStatusSchema } from './org-schemas.js';
import { SubscriptionStatusSchema } from './plan-schemas.js';

// role-based-dashboards — Phase 4: contract for GET /super-admin/overview
// (spec "Platform Overview Page" / "getPlatformOverview Endpoint"). Backs the
// super_admin snapshot: org counts, org distribution by status/niche, plan
// distribution (active subscriptions grouped by plan), and subscription
// aggregates (activeCount/mrrCents/byStatus) — ALL organizations, no polling
// (spec "Snapshot-Only Super Admin Overview").

export const PlatformOverviewResponseSchema = z.object({
  orgs: z.object({
    total: z.number().int().min(0),
    byStatus: z.record(OrgStatusSchema, z.number().int().min(0)),
    // Niche keys are the OrgNiche enum values (see org-schemas.ts) plus
    // 'unassigned' (null niche is surfaced as the literal string
    // 'unassigned' — design "Open questions").
    byNiche: z.record(z.string(), z.number().int().min(0)),
  }),
  plans: z.object({
    byPlan: z.array(
      z.object({
        planId: z.string().uuid(),
        planName: z.string(),
        orgCount: z.number().int().min(0),
      }),
    ),
  }),
  subscriptions: z.object({
    activeCount: z.number().int().min(0),
    // FIX 1 (review) — MRR grouped by currency (plans can be billed in
    // different currencies; a single conflated total would silently sum
    // e.g. USD cents and EUR cents into one meaningless number). Empty
    // array when there are no active subscriptions.
    mrrByCurrency: z.array(
      z.object({
        currency: z.string(),
        amountCents: z.number().int().min(0),
      }),
    ),
    byStatus: z.record(SubscriptionStatusSchema, z.number().int().min(0)),
  }),
});
export type PlatformOverviewResponse = z.infer<typeof PlatformOverviewResponseSchema>;
